// eslint-disable-next-line import/no-anonymous-default-export
export default {
  iconSize: 22,
  HST: 13,
};
